// @flow
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import RowLayout, { Header } from 'app/common/layouts/RowLayout';
import Loading from 'app/common/components/Loader';

import OrdersHistoryList from './OrdersHistoryList';
import OrdersData from '../OrdersData';


type Props = {
  onRedirectToCart?: () => void,
}

const OrderHistory = ({ onRedirectToCart }: Props) => {
  const { t } = useTranslation('shop');
  const { loading, shop } = useSelector(state => state.user, shallowEqual);
  const { user_id: userUuid } = shop;

  return (
    <React.Fragment>
      <RowLayout>
        <Header>{t('my_orders_header')}</Header>
      </RowLayout>
      {loading
        ? <Loading />
        : <OrdersData userUuid={userUuid}>
          <OrdersHistoryList onRedirectToCart={onRedirectToCart} />
        </OrdersData>}
    </React.Fragment>
  );
};

export default OrderHistory;
